import { AppRoutes } from "../types/enums/appRoutes";
import { PLANNING_VIEW_ALLOWED_ROLES } from "../types/enums/roleKeys";

interface RoleGatedItem {
  requiredRoles?: readonly string[] | "*";
}

export function hasAnyRole(
  userRoleKeys: readonly string[],
  requiredRoles?: readonly string[] | "*"
): boolean {
  if (!requiredRoles || requiredRoles === "*") return true;
  if (requiredRoles.length === 0) return true;
  return requiredRoles.some((role) => userRoleKeys.includes(role));
}

export function filterRoleGatedItems<T extends RoleGatedItem>(
  items: readonly T[],
  userRoleKeys: readonly string[]
): T[] {
  return items.filter((item) => hasAnyRole(userRoleKeys, item.requiredRoles));
}

export function resolveOnboardedHomeRoute(userRoleKeys: readonly string[]): string {
  return hasAnyRole(userRoleKeys, PLANNING_VIEW_ALLOWED_ROLES) ? AppRoutes.checklist : AppRoutes.settings;
}
